module.exports = __webpack_public_path__ + "static/img/jsyyy_talk.ca469e1.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/jsyyy_talk.png
// module id = 7P48
// module chunks = 0